import amplitude from 'amplitude-js';
import ReactGA from 'react-ga';

const { REACT_APP_AMPLITUDE_KEY, TRACKING_ID } = process.env;

amplitude.init(REACT_APP_AMPLITUDE_KEY, null, {
  includeReferrer: true,
  includeUtm: true,
  includeGclid: true,
});

ReactGA.initialize(TRACKING_ID);

export const addEvent = async (name, extra_data = {}, logToConsole = false) => {
  let extra = {
    ...extra_data,
  };

  // Simplify Call Data for Readability
  if (extra_data.call) {
    delete extra.call;
    extra = {
      ...extra,
      'Call Name': extra_data.call.chat_name,
    };
  }
  if (extra_data.deal) {
    delete extra.deal;
    extra = {
      ...extra,
      'Deal Name': extra_data.deal.name,
    };
  }
  if (extra_data.participant) {
    delete extra.participant;
    extra = {
      ...extra,
      'Participant Name': extra_data.participant.name,
    };
  }

  //   ReactGA.pageview(page);
  //   ReactGA.event({
  //     category, // Required
  //     action, // Required
  //     label,
  //   });

  amplitude.logEvent(name, extra);
};

export const intitializeAmplitude = (user) => {
  amplitude.getInstance().setUserProperties({
    id: user.id,
    email: user.email,
    name: `${user.first_name} ${user.last_name}`,
    is_superuser: user.is_superuser,
    company: user.company?.name,
  });
};

window.__ADD_EVENT__ = addEvent;
